import { ContractHistory } from "@/models/subscription/contract-history"
import { OrderStatusTypeEnum } from "@/enums"

export class EditPendingOrder {
    public id: number;
    public name: string|null;
    public orderId: string;
    public resourceName: {
        id: number,
        name: string,
        technical_products: []
    };
    public status: OrderStatusTypeEnum|null;

    constructor(base?: Partial<EditPendingOrder>){
        if(base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: ContractHistory) {
        if (!dto) {return null;}
        return new EditPendingOrder({
            id: dto.id,
            name: dto.new_value,
            orderId: dto.order_id,
            resourceName: JSON.parse(dto.resource_name as string),
            status: OrderStatusTypeEnum[dto.status as OrderStatusTypeEnum] ? dto.status as OrderStatusTypeEnum: null
        });
    }
}